"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePropertySchema = void 0;
const react_1 = require("react");
const utils_1 = require("../../utils");
const usePropertySchema = (schema, path) => {
    return (0, react_1.useMemo)(() => {
        try {
            return {
                ...(0, utils_1.getChildSchema)(schema, path || []),
                error: undefined,
            };
        }
        catch (error) {
            // Property path cannot be resolved to a property in the schema.
            return {
                schema: undefined,
                required: undefined,
                error,
            };
        }
    }, [schema, path]);
};
exports.usePropertySchema = usePropertySchema;
//# sourceMappingURL=usePropertySchema.js.map